export default __webpack_public_path__ + "static/media/trees-light-pan.37a61422.gif";